/**
 * Platform style utilities.
 * Reads REACT_APP_BRAND_HOST_FBE; Lumio is the default when empty or undefined.
 */

export enum Brand {
	LUMIO = "lumio",
	FBE_RSKN = "fbe_rskn",
}

const DEFAULT_BRAND = Brand.LUMIO;

/**
 * Raw value from env (trimmed). May be undefined, empty, or the string "undefined".
 * In the browser, returns the env value only when the current host (hostname, plus
 * port when not 80/443) ends with it; SSR or missing window uses env as-is.
 */
export function getBrandRaw(): string | undefined {
	const hostFbe = process.env.REACT_APP_BRAND_HOST_FBE?.trim() || undefined;
	console.log("hostFbe", hostFbe);
	if (!hostFbe) return undefined;
	if (typeof window === "undefined") return Brand.LUMIO;
	const hostname = window.location.hostname.toLowerCase();
	const port = window.location.port;
	const host =
		port && port !== "80" && port !== "443" ? `${hostname}:${port}` : hostname;
	console.log("host", host);
	const suffix = hostFbe.toLowerCase();
	const suffixForEnds = suffix.startsWith(".") ? suffix : "." + suffix;
	return host === suffix || host.endsWith(suffixForEnds) ? Brand.FBE_RSKN : Brand.LUMIO;
}

/**
 * Normalized brand string. Defaults to Lumio when env is empty or "undefined".
 */
export function getBrand(): string {
	const raw = getBrandRaw();
	return raw && raw !== "undefined" ? raw : DEFAULT_BRAND;
}

/**
 * True when the current style is Lumio (lumio, empty, or "undefined").
 * Use for theme/palette and Lumio-specific styling (e.g. primary color).
 */
export function isLumio(): boolean {
	const raw = getBrandRaw();
	return !raw || raw === "undefined" || raw === Brand.LUMIO;
}

/**
 * True when to use the Lumio favicon (lumio, empty, "undefined", or "default").
 * Use for favicon selection.
 */
export function shouldUseLumioFavicon(): boolean {
	const raw = getBrandRaw();
	return !raw || raw === "undefined" || raw === Brand.LUMIO || raw === "default";
}
